// extracted by mini-css-extract-plugin
export default {"wrapper":"InitialStep_wrapper__624c7","title":"InitialStep_title__j89xI","text":"InitialStep_text__QEpg2","button":"InitialStep_button__E4wjN"};